import { Box } from "@mui/material";
// import { useNavigate, useParams } from "react-router-dom";
import Flex from "../../../../../../../../components/Flex";
import Text from "../../../../../../../../components/Text";

export const AssessmentTitle = () => {
  // const { patientId } = useParams();
  // const navigate = useNavigate();
  // const isVisitNotePage = window.location.pathname.includes("/visit-note");

  // const handleNavigateToAssessment = () => {
  //   navigate(
  //     `/app/provider/patients/new-patient/${
  //       patientId ?? ""
  //     }/assessment/assessment
  //   );
  // };

  return (
    <Flex justifyContent="space-between" alignItems="center" mb={4} mx={1}>
      <Flex alignItems={"center"} gap={1}>
        {/* <Text variant="h5" fontWeight="600">
          Assessments
        </Text> */}

        <Text variant="body2" color="text.secondary">
          Generated assigned assessments/symptom rating scales
        </Text>
      </Flex>
      <Box sx={{ display: "flex", gap: 3 }}>
        {/* <Link href="#" underline="hover" sx={{ fontSize: "0.875rem" }}>
          Copy latest Assessment results
        </Link> */}

        {/* {!isVisitNotePage && (
          <Text
            c="primary"
            onClick={() => handleNavigateToAssessment()}
            sx={{
              fontSize: "0.875rem",
              ":hover": { textDecoration: "underline" },
              cursor: "pointer",
            }}
          >
            View all
          </Text>
        )} */}
      </Box>
    </Flex>
  );
};
